<button
  (click)="openQuickPanel.emit()"
  class="button"
  fxFlex="grow"
  mat-button
  [matTooltip]="
    alertService.alerts.length +
    ' Alerts (' +
    alertService.criticalAlertsLength +
    ' critical, ' +
    (alertService.alerts.length - alertService.criticalAlertsLength) +
    ' non-critical)'
  "
>
  <i class="icon icon-bell gray-icon"></i>
  <!-- alert badges -->
  <div
    class="alerts-count"
    [class.alerts-multiple]="
      alertService.criticalAlertsLength &&
      alertService.alerts.length - alertService.criticalAlertsLength > 0
    "
  >
    <!-- non-critical badge -->
    @if (alertService.alerts.length - alertService.criticalAlertsLength > 0) {
    <i class="icon-checkbox-blank-circle amber-600-fg non-critical"></i>
    }
    <!-- critical badge -->
    @if (alertService.criticalAlertsLength) {
    <i class="icon-checkbox-blank-circle red-700-fg critical"></i>
    }
  </div>
</button>
